module.exports = __webpack_public_path__ + "img/parameter.0b28122f.png";